<template>
  <div class="cost">
    <!-- “cost”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @changeGoodsType="changeGoodsType"
      @projectChange="projectChange"
      @periodChange="periodChange"
      @productCodeChange="productCodeChange"
    ></sirui-search>
    <!-- cost -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              <!-- {{ scope.row[item.field]|formatTableColumn(item.format)}} -->
              {{ $utils.toNumber(scope.row[item.field]).toFixed(2) }}
            </span>
            <span v-else-if="item.optionList">
              {{ getSelectLabel(scope.row[item.field], item.optionList) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
          <!-- <template slot-scope="scope">
            <span v-if="item.field === 'goodsType'">
              <dict-span dictType="productType" v-model="scope.row[item.field]"></dict-span>
            </span>
            <span v-else>{{scope.row[item.field]}}</span>
          </template> -->
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SiruiSearch from "@/components/SiruiSearch";
  import DataBaseAPI from '@/api/dataBase';
  import costAPI from '@/api/productCenter/costDetails';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  // import DictSpan from '@/components/DictSpan';
  import baseUrl from '@/common/config';
  export default {
    name: 'costDetailsList',
    mixins: [tableMixins],
    components: {},

    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        materialCategoryList: function (state) {
          let mclist = state.dict.dictListMap.produce_product_category;
          let gtlist = state.dict.dictListMap.productType;
          //配料类别=原料大类+辅料
          gtlist.map((item) => {
            if (['0'].indexOf(item.value) != -1) {
              mclist.unshift(item);
            }
          });
          return mclist;
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      columnListDefault() {
        return [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          // { type: "seq", visible: true, width: "50", fixed: "left", title: "table.index" },
          //公司名称
          {
            field: 'businessCompanyName',
            title: this.$t('costDetailsList.column.businessCompanyName'),
          },
          //部门名称
          {
            field: 'businessDepartmentName',
            title: this.$t('costDetailsList.column.businessDepartmentName'),
          },
          //账期名称
          { field: 'periodName', title: this.$t('costDetailsList.column.periodName') },
          //项目名称
          { field: 'projectName', title: this.$t('costDetailsList.column.projectName') },
          //商品编码
          { field: 'productCode', title: this.$t('costDetailsList.column.productCode') },
          {
            field: 'goodsType',
            title: 'costDetailsList.column.goodsType',
            visible: true,
            width: 80,
            optionList: this.materialCategoryList,
            //dictType:"material_category"
          },
          {
            field: 'productName',
            title: 'costDetailsList.column.productName',
            visible: true,
            width: 120,
          },
          //单位
          {
            field: 'productUnit',
            title: 'costDetailsList.column.productUnit',
            visible: true,
            width: 140,
            dictType: 'produce_basic_unit',
          },
          //结算日期-期间
          {
            field: 'settlementDate',
            title: 'costDetailsList.column.settlementDate',
            visible: true,
            width: 140,
          },
          //期初累计领用数量
          {
            field: 'openingRecipientsCount',
            title: 'costDetailsList.column.openingRecipientsCount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          //期初累计耗用数量
          {
            field: 'openingConsumptionCount',
            title: 'costDetailsList.column.openingConsumptionCount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          //期初差异数量
          {
            field: 'openingDiffCount',
            title: 'costDetailsList.column.openingDiffCount',
            visible: true,
            width: 110,
            format: 'formatAmount',
          },
          //期初差异金额
          {
            field: 'openingDiffAmount',
            title: 'costDetailsList.column.openingDiffAmount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          //本期实际领用数量
          {
            field: 'currentRecipientsCount',
            title: 'costDetailsList.column.currentRecipientsCount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          //本期实际耗用数量
          {
            field: 'currentConsumptionCount',
            title: 'costDetailsList.column.currentConsumptionCount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //本期差异数量
          {
            field: 'currentDiffCount',
            title: 'costDetailsList.column.currentDiffCount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //本期平均单价
          {
            field: 'currentCostPrice',
            title: 'costDetailsList.column.currentCostPrice',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //本期差异金额
          {
            field: 'currentDiffAmount',
            title: 'costDetailsList.column.currentDiffAmount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //期末累计领用数量
          {
            field: 'endRecipientsCount',
            title: 'costDetailsList.column.endRecipientsCount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //期末累计耗用数量
          {
            field: 'endConsumptionCount',
            title: 'costDetailsList.column.endConsumptionCount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //期末差异数量
          {
            field: 'endDiffCount',
            title: 'costDetailsList.column.endDiffCount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
          //期末差异金额
          {
            field: 'endDiffAmount',
            title: 'costDetailsList.column.endDiffAmount',
            visible: true,
            width: 140,
            format: 'formatAmount',
          },
        ];
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   公司代码--公司
          {
            name: this.$t('costDetailsList.column.businessCompanyCode'),
            prop: 'businessCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
          },
          //   事业部门--业务部门
          {
            prop: 'businessDepartmentCode',
            name: this.$t('costDetailsList.column.businessDepartmentCode'),
            type: 'select',
            placeholder: this.$t('costDetailsList.column.businessDepartmentCode'),
            options: this.departmentList,
            clearable: true,
          },
          //操作人
          {
            type: 'searchTableSpec',
            prop: 'createPersonNo',
            isMultiple: true,
            name: this.$t('costDetailsList.column.createPersonNo'),
            searchType: 'personnel',
            clearable: true,
          },
          {
            // 账期
            prop: 'periodName',
            name: this.$t('costDetailsList.column.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
          // 创建日期
          {
            prop: 'createDateStart',
            name: this.$t('costDetailsList.column.createDateStart'),
            type: 'startDaterangePicker',
            clearable: true,
          },
          {
            prop: 'createDateEnd',
            name: this.$t('costDetailsList.column.createDateEnd'),
            type: 'endDaterangePicker',
            clearable: true,
          },
          // 结算日期
          {
            prop: 'settlementDateStart',
            name: this.$t('costDetailsList.column.settlementDateStart'),
            type: 'startDaterangePicker',
            clearable: true,
          },
          {
            prop: 'settlementDateEnd',
            name: this.$t('costDetailsList.column.settlementDateEnd'),
            type: 'endDaterangePicker',
            clearable: true,
          },
          //商品大类
          {
            prop: 'goodsType',
            name: this.$t('costDetailsList.column.goodsType'),
            type: 'dict',
            dictType: 'product_type',
            // changeMethod: "changeGoodsType",
            clearable: true,
          },
          //商品编号-商品小类
          {
            prop: 'productName',
            name: this.$t('costDetailsList.column.productName'),
            type: 'searchTableSpec',
            searchType: 'produceProduct',
            changeMethod: 'productCodeChange',
            isMultiple: true,
            extraData: {
              productClass: '0',
            },
            //options: this.productDetailList
          },
          /* {
          prop: "productName",
          name: this.$t("costDetailsList.column.productName"),
          type: "input",
         // options: this.productDetailList,
          clearable: true
        }, */
          // 平均单价
          {
            name: this.$t('costDetailsList.column.currentCostPrice'),
            prop: ['currentCostPriceCondition', 'currentCostPrice'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.currentCostPrice'),
            clearable: true,
          },
          // 期初领用数量
          {
            name: this.$t('costDetailsList.column.openingRecipientsCount'),
            prop: ['openingRecipientsCountCondition', 'openingRecipientsCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.openingRecipientsCount'),
            clearable: true,
          },
          // 耗用数量
          {
            name: this.$t('costDetailsList.column.openingConsumptionCount'),
            prop: ['openingConsumptionCountCondition', 'openingConsumptionCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.openingConsumptionCount'),
            clearable: true,
          },
          // 差异数量
          {
            name: this.$t('costDetailsList.column.openingDiffCount'),
            prop: ['openingDiffCountCondition', 'openingDiffCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.openingDiffCount'),
            clearable: true,
          },
          // 差异金额
          {
            name: this.$t('costDetailsList.column.openingDiffAmount'),
            prop: ['openingDiffAmountCondition', 'openingDiffAmount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.openingDiffAmount'),
            clearable: true,
          },
          // 本期领用数量
          {
            name: this.$t('costDetailsList.column.currentRecipientsCount'),
            prop: ['currentRecipientsCountCondition', 'currentRecipientsCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.currentRecipientsCount'),
            clearable: true,
          },
          // 耗用数量
          {
            name: this.$t('costDetailsList.column.currentConsumptionCount'),
            prop: ['currentConsumptionCountCondition', 'currentConsumptionCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.currentConsumptionCount'),
            clearable: true,
          },
          // 差异数量
          {
            name: this.$t('costDetailsList.column.currentDiffCount'),
            prop: ['currentDiffCountCondition', 'currentDiffCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.currentDiffCount'),
            clearable: true,
          },
          // 差异金额
          {
            name: this.$t('costDetailsList.column.currentDiffAmount'),
            prop: ['currentDiffAmountCondition', 'currentDiffAmount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.currentDiffAmount'),
            clearable: true,
          },
          // 期末领用数量
          {
            name: this.$t('costDetailsList.column.endRecipientsCount'),
            prop: ['endRecipientsCountCondition', 'endRecipientsCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.endRecipientsCount'),
            clearable: true,
          },
          // 耗用数量
          {
            name: this.$t('costDetailsList.column.endConsumptionCount'),
            prop: ['endConsumptionCountCondition', 'endConsumptionCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.endConsumptionCount'),
            clearable: true,
          },
          // 差异数量
          {
            name: this.$t('costDetailsList.column.endDiffCount'),
            prop: ['endDiffCountCondition', 'endDiffCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.endDiffCount'),
            clearable: true,
          },
          // 差异金额
          {
            name: this.$t('costDetailsList.column.endDiffAmount'),
            prop: ['endDiffAmountCondition', 'endDiffAmount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('costDetailsList.column.endDiffAmount'),
            clearable: true,
          },
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('costDetailsList.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
            changeMethod: 'projectChange',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          businessCompanyCode: '', //公司信息
          businessDepartmentCode: '', //部门信息
          createPersonNo: '', //操作人
          createDateStart: '', //创建日期起
          createDateEnd: '', //创建日期止
          settlementDateStart: '', //结算日期起
          settlementDateEnd: '', //结算日期止
          goodsType: '', //商品大类
          productName: '', //商品编码 商品小类
          currentCostPriceCondition: '',
          currentCostPrice: undefined, //平均单价
          openingRecipientsCountCondition: '',
          openingRecipientsCount: undefined, //期初领用数量
          openingConsumptionCountCondition: '',
          openingConsumptionCount: undefined, //耗用数量
          openingDiffCountCondition: '',
          openingDiffCount: undefined, //差异数量
          openingDiffAmountCondition: '',
          openingDiffAmount: undefined, //差异金额
          currentRecipientsCount: undefined, //本期领用数量
          currentConsumptionCountCondition: '',
          currentConsumptionCount: undefined, //耗用数量
          currentDiffCountCondition: '',
          currentDiffCount: undefined, //差异数量
          currentDiffAmountCondition: '',
          currentDiffAmount: undefined, //差异金额
          currentRecipientsCountCondition: '',
          endRecipientsCount: undefined, //期末领用数量
          endConsumptionCountCondition: '',
          endConsumptionCount: undefined, //耗用数量
          endDiffCountCondition: '',
          endDiffCount: undefined, //差异数量
          endDiffAmountCondition: '',
          endDiffAmount: undefined, //差异金额
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
        },
        tableData: [], //列表数据
        companyList: [], // 公司
        departmentList: [],
        slipDepartmentList: [], // 部门
        productDetailList: [], //商品编号
        // materialCategoryList: this.$baseRequest.getDictListMapByType('produce_product_category'),//原料大类
        //productTypeList:this.$baseRequest.getDictListMapByType('productType'),//主辅料
        identification: [
          // 明细标示
          {
            label: this.$t('costDetailsList.column.redBack'),
            value: this.$t('costDetailsList.column.redBack'),
          },
        ],
        productCountConditionList: [
          // 商品数量条件
          { value: 1, label: this.$t('costDetailsList.search.equal') }, //等于
          { value: 2, label: this.$t('costDetailsList.search.notEqual') }, //不等于
          { value: 3, label: this.$t('costDetailsList.search.gt') }, //大于
          { value: 4, label: this.$t('costDetailsList.search.lt') }, //小于
        ],
      };
    },
    mounted() {
      //this.getData();
      this.getCompany();
      this.getButtonList();
      this.getCurrentDepartment();
      //this.getDictList();
    },
    methods: {
      // 获取列表数据
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.query.createPersonNo =
          this.query.createPersonNo && this.query.createPersonNo[0]
            ? this.query.createPersonNo[0].id
            : '';
        if (!this.query.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        const params = { ...this.query, pageNum, pageSize };
        this.load = true;
        this.$axios.post(costAPI.COST_LIST_API, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // async getCompany() { // 公司
      //   let res = await this.$baseRequest.getCompanyList();
      //   if (res) {
      //     this.companyList = res;
      //   }
      // },
      // 公司名称
      getDictList() {
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      /* //切换公司
    changeCompany(val) {
      this.slipDepartmentList = [];
      this.query.businessDepartmentCode = "";
      this.slipCompanyList.find(item => {
        if (item.value === val.val) {
          this.initDepartment();
        }
      });
    },
    //业务部门
    initDepartment(val) {
      this.$axios
        .post(
          DataBaseAPI.LIST_DEPARTMENT_API +
            "/" +
            this.query.businessCompanyCode
        )
        .then(res => {
          if (0 == res.data.code) {
            this.slipDepartmentList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
    }, */
      //切换公司

      /*async getDepartment(companyCode) { // 部门
      if (companyCode) {
        let res = await this.$baseRequest.getDepartment(companyCode);
        if (res) {
          this.slipDepartmentList = res;
        }
      } else {
        this.slipDepartmentList = [];
      }
    },
     */
      // 获取当前登录用户所在的公司部门
      async getCurrentDepartment() {
        let personDepartmentInfo = [];
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };

        await this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            personDepartmentInfo = res.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });

            this.query.businessDepartmentCode = personDepartmentInfo[0].value;
            this.departmentList = personDepartmentInfo;
          }
        });
        //this.getData();
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.businessDepartmentCode = null;
        this.getDepartment(val.val);
      },
      // 切换商品大类 获取商品编号
      async changeGoodsType(val) {
        this.productDetailList = [];
        this.query.productName = '';
        const selectStatus = await this.$axios.get(costAPI.COSTDETAILS_PRODUCTCODE_API, {
          productType: val.val,
        });
        if (selectStatus.data.code == 0) {
          this.productDetailList = selectStatus.data.data;
        }
      },
      projectChange() {
        // 切换项目
        this.query.periodCode = this.query.periodName = null;
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
        } else {
          this.query.periodCode = this.query.periodName = null;
        }
      },
      productCodeChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.productCode = res[0].productCode;
          this.query.productName = res[0].productName;
        } else {
          this.query.productCode = null;
          this.query.productName = null;
        }
      },
      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // 按钮
      chooseClick(type) {
        if (type === 'add') {
          let path = {
            path: '/production/costAdd',
            name: 'costAdd',
            meta: {
              keepAlive: true,
              title: '新增领用明细',
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          if (this.tableData && this.tableData.length === 0) {
            return this.tips('noExport');
          }
          this.handleExport();
        }
      },
      //列表双击p
      dblclickEvent(value) {
        console.log(value);
        /* let path = {
        path: "/production/costDetails",
        name: "costDetails",
        meta: {
          keepAlive: false,
          title: "领用明细详情"
        },
        query: {}
      };
      this.$store.dispatch("tagsView/addTabView", path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      }); */
      },
      // 导出
      /* handleExport() {
      let tableColumn = this.$refs.siruiTable.getTableColumn().visibleColumn;
      let showColumns = [];
      let idList = [];
      tableColumn.forEach(item => {
        if (item.property) showColumns.push({ prop: item.property });
      });
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach(item => {
          idList.push(item.id);
        });
      }
      // const { tenantCode, companyCode, departmentCode } = this.userInfo;
      // let params = { tenantCode, companyCode, departmentCode };
      let params = {};
      params = Object.assign(params, this.query);
      params.columns = showColumns;
      params.ids = idList;
      this.$axios.post(costAPI.COSTDETAILS_SAVE_API, params).then(res => {
        if (res.data.code === 0) {
          window.location.href = res.data.data;
        }
      });
    }, */
      // 导出
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${costAPI.COSTDETAILS_SAVE_API}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${costAPI.COSTDETAILS_SAVE_API}?${params}&access_token=${this.token.access_token}`;
        }
      },
      //提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`costDetailsList.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
